import { render, staticRenderFns } from "./FilterNew.vue?vue&type=template&id=13ad4d79&"
import script from "./FilterNew.vue?vue&type=script&lang=js&"
export * from "./FilterNew.vue?vue&type=script&lang=js&"
import style0 from "./FilterNew.vue?vue&type=style&index=0&id=13ad4d79&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports